import React from 'react';
import { FormGroup } from 'reactstrap';
import { InputLabel } from '../../../shared/components/InputLabel';
import Error from '../../../shared/components/form/Error';

export function FormInput({
  label = '',
  name = '',
  type = 'text',
  value,
  error = '',
  required = false,
  optional = false,
  labelNote = '',
  belowLabel = null,
  helperText = '',
  onChange,
  className,
  wrapperClassName = 'col-md-4',
  inputClassName = '',
  ...restProps
}) {
  return (
    <div className={wrapperClassName}>
      <div className="form__form-group">
        <InputLabel required={required}>
          {label}
          {optional ? (
            <span className="staff-field-note">(optional)</span>
          ) : null}
          {labelNote ? (
            <span className="staff-field-note">({labelNote})</span>
          ) : null}
        </InputLabel>
        {belowLabel ? (
          <div className="staff-label-below">{belowLabel}</div>
        ) : null}
        <div className="form__form-group-field">
          <FormGroup className={className}>
            <input
              className={`form-control ${inputClassName}`.trim()}
              name={name}
              type={type}
              value={value}
              maxLength={50}
              onChange={onChange}
              {...restProps}
            />
            {error && <Error text={error} />}
          </FormGroup>
        </div>
        {helperText ? <p className="staff-field-help">{helperText}</p> : null}
      </div>
    </div>
  );
}
